import i18next from "i18next";

export const FindPreferredLang = () => {
  const initialLang = [
    {
      ItemValue:
        i18next.language === "en"
          ? "English"
          : i18next.language === "fa"
          ? "فارسی"
          : i18next.language === "ar"
          ? "العربیه"
          : "",
      ItemContent:
        i18next.language === "en"
          ? "English"
          : i18next.language === "fa"
          ? "فارسی"
          : i18next.language === "ar"
          ? "العربیه"
          : "",
    },
  ];
  return initialLang;
};
